// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1MRgE","insightsList":"newBusinessInsightsMenu_insightsList__3f44O","active":"newBusinessInsightsMenu_active__3rDXv"};